import { getSelected } from 'app/multi-select/selectors';
import type { SagaIterator } from 'redux-saga';
import { all, put, select, takeLatest } from 'redux-saga/effects';
import type { ActionType } from 'typesafe-actions';
import { deleteContent } from '../content/actions.js';
import { getDefaultLocale } from '../schema/index.js';
import { deleteSelected } from './actions.js';
import { CONTENT_LIST_NAME } from './constants.js';

export function* deleteSelectedSaga(action: ActionType<typeof deleteSelected>): SagaIterator {
  const locale = yield select(getDefaultLocale);
  const selected: Set<string> = yield select(getSelected, {
    multiSelectName: CONTENT_LIST_NAME
  });
  yield all(
    [...selected].map((id) =>
      put(
        deleteContent.requested(undefined, {
          contentId: id,
          shapeId: action.payload,
          locale
        })
      )
    )
  );
}

export default function* root(): SagaIterator {
  yield takeLatest(deleteSelected, deleteSelectedSaga);
}
